export interface TaskMaster {
  id: number
  isActive: boolean
  taskTitle: string
  taskTypeDescription: string
  taskCode: string
}

export enum TaskStatus {
  'Not Started' = 1,
  'In Progress' = 2,
  'Hold' = 3,
  'Problem' = 4,
  'Waiting' = 5,
  'Cancelled' = 8,
  'Completed' = 9,
  'Not Applicable' = 10,
}

// implements DateSeries
export interface JobTask {
  id: number

  jobId: number
  jobNumber: string
  taskMasterId?: number
  taskMasterTitle?: string

  startDate: string | null
  endDate: string | null
  sentDate: string | null

  statusId: TaskStatus
  allocatedTo: string
  division: string
  stage: string | null
  vendor: string
  salesRep: string | null
  siteManager: string | null
}
